export const SERP_HEADER_EXPANDED_ZONE = 40;

export const SERP_HEADER_COLLAPSE_FROM = 80;

export const SERP_HEADER_SCROLL_DELTA = 4;
